// extracted by mini-css-extract-plugin
export default {"disableClick":"Vtex_2","typeCircle":"Q57Sd1","typeSquare":"plI5OO","typeNone":"TV5Wwe"};